export const PROCEDURE_TREE_URL = '/api/proctree.do'
export const PROCEDURE_TREE_FILTER_URL = '/api/proFilterByQuery.do?query='
export const PROCEDURE_IPDN_TREE_URL = '/api/procipdntree.do'
export const PROCEDURE_IPDN_TREE_FILTER_URL = '/api/proipdnFilterByQuery.do?query='
export const ICD10_TREE_URL = '/api/icd10tree.do'
export const ICD10_TREE_FILTER_URL = '/api/icd10FilterByQuery.do?query='
export const ICD10_IPDN_TREE_URL = '/api/icd10ipdntree.do'
export const ICD10_IPDN_TREE_FILTER_URL = '/api/icd10ipdnFilterByQuery.do?query='